import { Router } from '@angular/router';
import { SearchGlobalService } from './../../../../shared/services/search-global.service';

import {
    Component,
    ElementRef,
    OnInit,
    Renderer2,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-search-global',
    templateUrl: './search-global.component.html',
    styleUrls: ['./search-global.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class SearchGlobalComponent implements OnInit {
    searchQuery: string = '';
    searchRecommend: any;
    selectedIndex: number = -1;
    searchTimer: any;
    isLoading: boolean = false;
    previousSearchQuery: string = '';
    @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;
    @ViewChild('recommendBox') recommendBox: ElementRef;
    @ViewChild('boxSearch') boxSearch: ElementRef;
    @ViewChild('del') del: ElementRef;

    constructor(
        private searchService: SearchGlobalService,
        private router: Router,
        private toastService: ToastrService,
        private renderer: Renderer2
    ) {}

    ngOnInit(): void {
        this.renderer.listen('document', 'click', (event: MouseEvent) => {
            const clickedElement = event.target as Node;
            if (!this.recommendBox.nativeElement.contains(clickedElement)) {
                this.closeRec();
            }
            if (this.searchInput.nativeElement.contains(clickedElement)) {
                if (this.searchRecommend && this.searchRecommend.length > 0) {
                    this.openRec();
                }
            }
        });
    }

    onSearch() {
        this.isLoading = true;
        this.previousSearchQuery = this.searchQuery;
        this.searchService.rec(this.searchQuery).subscribe(
            (results: any) => {
                this.isLoading = false;
                this.searchRecommend = results.result;
                this.selectedIndex = -1;
                if (this.searchRecommend.length > 0) {
                    this.openRec();
                } else {
                    this.closeRec();
                }
            },
            (error: any) => {
                this.isLoading = false;
          
            }
        );
    }

    handleInputChange() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
            if (this.searchQuery.trim() !== this.previousSearchQuery) this.onSearch();
        }, 250);
    }

    handleKeyDown(event: KeyboardEvent) {
        if (event.key === 'ArrowDown' && this.selectedIndex < this.searchRecommend.length - 1) {
            event.preventDefault();
            this.selectedIndex++;
        } else if (event.key === 'ArrowUp' && this.selectedIndex > 0) {
            event.preventDefault();
            this.selectedIndex--;
        }
        if (this.selectedIndex >= 0 && this.searchRecommend[this.selectedIndex]) {
            this.searchQuery = this.searchRecommend[this.selectedIndex];
        }
        if (event.key === 'Enter') {
            event.preventDefault();
            if (this.searchQuery.length) {
                this.onSearchItemClick(this.searchQuery);
            }
        }
    }

    handleDelInput() {
        this.searchQuery = '';
        this.searchRecommend = [];
        this.closeRec();
    }

    onSearchItemClick(searchTerm: string) {
        this.router.navigate(['/search/query-global'], {
            queryParams: { q: searchTerm },
        });
    }

    closeRec() {
        if (this.boxSearch && this.boxSearch.nativeElement) {
            this.boxSearch.nativeElement.classList.remove('bar-data');
            this.boxSearch.nativeElement.classList.add('bar');
        }
        this.recommendBox.nativeElement.classList.add('hidden');
    }

    openRec() {
        if (this.boxSearch && this.boxSearch.nativeElement) {
            this.boxSearch.nativeElement.classList.add('bar-data');
            this.boxSearch.nativeElement.classList.remove('bar');
        }
        this.recommendBox.nativeElement.classList.remove('hidden');
    }
}
